import React from 'react';
import type { ContentAudience } from '../utils/audience';

interface AudienceOption {
    value: ContentAudience;
    label: string;
    hint: string;
}

const AUDIENCE_OPTIONS: AudienceOption[] = [
    { value: 'external', label: 'External', hint: 'Visible to practices' },
    { value: 'internal', label: 'Internal', hint: 'Staff only, shown in the admin app' }
];

interface AudienceFieldProps {
    value: ContentAudience;
    onChange: (next: ContentAudience) => void;
    disabled?: boolean;
}

/** Radio cards on RetainerSelector's pattern: shared-ui has no generic choice control. */
export const AudienceField: React.FC<AudienceFieldProps> = ({
    value,
    onChange,
    disabled = false
}) => (
    <fieldset className="flex flex-col gap-2" disabled={disabled}>
        <legend className="mb-2 text-xs font-semibold text-gray-700">Audience</legend>
        <div className="grid grid-cols-2 gap-2">
            {AUDIENCE_OPTIONS.map((option) => {
                const active = value === option.value;
                return (
                    <label
                        key={option.value}
                        className={`flex items-start gap-2.5 cursor-pointer rounded-xl border px-3 py-2.5 transition-colors ${
                            active
                                ? 'border-gray-800 bg-gray-50'
                                : 'border-gray-200 hover:border-gray-300'
                        } ${disabled ? 'opacity-60 pointer-events-none' : ''}`}
                    >
                        <input
                            type="radio"
                            name="resource-audience"
                            value={option.value}
                            checked={active}
                            onChange={() => onChange(option.value)}
                            className="mt-0.5 w-4 h-4 accent-gray-800 flex-shrink-0"
                        />
                        <span className="flex flex-col gap-0.5">
                            <span className="text-sm font-semibold text-gray-800">
                                {option.label}
                            </span>
                            <span className="text-xs text-gray-500">{option.hint}</span>
                        </span>
                    </label>
                );
            })}
        </div>
    </fieldset>
);

export default AudienceField;
